export const fieldFindRegExp = /\{\{(.*?)\}\}/g
export const dateNowRegExp = /DATENOW\((.*?)\)/g
export const fieldReplaceRegExp = /^\{\{|\}\}$/g
export const fieldConnector = '-_-'
export const tableAndFieldConnector = '-->'

export const formulaTypeOptions = {
  'Y-M-D': 'YYYY-MM-DD',
  'Y-M-D h:m': 'YYYY-MM-DD HH:mm',
  'Y-M-D h:m:s': 'YYYY-MM-DD HH:mm:ss',
  'Y': 'YYYY',
  'M': 'MM',
  'D': 'DD',
}

export const numberFields = ['number', 'money', 'percentage']
export const dateFields = ['date', 'datetime', 'time', 'year', 'month']

export const FORMULA_SCENE = {
  TABLE: 'TABLE',
  FORM: 'FORM',
  DETAIL: 'DETAIL',
  TABLE_HEADER: 'TABLE_HEADER'
}

export const dateSettings = {
  keyMaps: ['Y', 'Q', 'M', 'D', 'W', 'H', 'MIN', 'S'],
  Y: { value: 1 * 60 * 60 * 24 * 365, method: 'GETYEAR' },
  Q: { value: 1 * 60 * 60 * 24 * 30 * 3, method: 'GETQUARTER' },
  M: { value: 1 * 60 * 60 * 24 * 30, method: 'GETMONTH' },
  D: { value: 1 * 60 * 60 * 24, method: 'GETDAY' },
  W: { value: 1 * 60 * 60 * 24 * 7, method: 'GETWEEK' },
  H: { value: 1 * 60 * 60, method: 'GETHOUR' },
  MIN: { value: 1 * 60, method: 'GETMINUTE' },
  S: { value: 1, method: 'GETSECOND' }
}

export const operations = [
  { title: '+', desc: 'table.col-add.calc.operate-plus', descZDY: '两个数相加' },
  { title: '-', desc: 'table.col-add.calc.operate-reduce', descZDY: '两个数相减' },
  { title: '*', desc: 'table.col-add.calc.operate-multiply', descZDY: '两个数相乘' },
  { title: '/', desc: 'table.col-add.calc.operate-divide', descZDY: '两个数相除' },
  { title: '(', desc: 'table.col-add.calc.brackets-left', descZDY: '左括号' },
  { title: ')', desc: 'table.col-add.calc.brackets-right', descZDY: '右括号' },
  { title: '>', desc: 'table.col-add.calc.greater-than', descZDY: '大于' },
  { title: '>=', desc: 'table.col-add.calc.greater-than-equal', descZDY: '大于等于' },
  { title: '<', desc: 'table.col-add.calc.less-than', descZDY: '小于' },
  { title: '<=', desc: 'table.col-add.calc.less-than-equal', descZDY: '小于等于' },
  { title: '==', desc: 'table.col-add.calc.equal', descZDY: '等于' },
  { title: '!=', desc: 'table.col-add.calc.not-equal', descZDY: '不等于' },
]

export const dateOptions = [
  { title: 'table.col-add.calc.field-time-y', key: 'y' },
  { title: 'table.col-add.calc.field-time-q', key: 'q' },
  { title: 'table.col-add.calc.field-time-m', key: 'm' },
  { title: 'table.col-add.calc.field-time-d', key: 'd' },
  { title: 'table.col-add.calc.field-time-w', key: 'w' },
  { title: 'table.col-add.calc.field-time-h', key: 'h' },
  { title: 'table.col-add.calc.field-time-min', key: 'MIN' },
  { title: 'table.col-add.calc.field-time-s', key: 's' }
]

export const resultTypeOptions = [
  { label: '时间戳', value: '' },
  { label: '年-月-日', value: 'Y-M-D' },
  { label: '年-月-日 时:分', value: 'Y-M-D h:m' },
  { label: '年-月-日 时:分:秒', value: 'Y-M-D h:m:s' },
  { label: '年', value: 'Y' },
  { label: '月', value: 'M' },
  { label: '日', value: 'D' }
]